import { render, staticRenderFns } from "./OrganisationDetail.vue?vue&type=template&id=37837f79&scoped=true"
import script from "./OrganisationDetail.vue?vue&type=script&lang=js"
export * from "./OrganisationDetail.vue?vue&type=script&lang=js"
import style0 from "./OrganisationDetail.vue?vue&type=style&index=0&id=37837f79&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37837f79",
  null
  
)

export default component.exports